module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indice-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stop($event)
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-icon indice-trigger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("自定义指标")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "q-custom-indices form"
  }, [_c('i', {
    staticClass: "triangle"
  }), (_vm.hasSpreadIndice) ? _c('div', {
    staticClass: "spread-indices"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("推广指标：")]), _c('div', {
    staticClass: "control"
  }, [_c('ul', _vm._l((_vm.spread), function(item) {
    return _c('li', {
      key: item[1]
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.changeIndice(item[0])
        }
      }
    }, [_c('span', {
      class: {
        checked: _vm.model[item[0]]
      }
    }), _vm._v(_vm._s(item[1]))])])
  }))])]) : _vm._e(), _c('div', {
    staticClass: "flux-indices"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("基础流量指标：")]), _c('div', {
    staticClass: "control"
  }, [_c('ul', _vm._l((_vm.flux), function(item) {
    return _c('li', {
      key: item[1]
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.changeIndice(item[0])
        }
      }
    }, [_c('span', {
      class: {
        checked: _vm.model[item[0]]
      }
    }), _vm._v(_vm._s(item[1]))])])
  }))])]), _c('div', {
    staticClass: "quality-indices"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("流量质量指标：")]), _c('div', {
    staticClass: "control"
  }, [_c('ul', _vm._l((_vm.quality), function(item) {
    return _c('li', {
      key: item[1]
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.changeIndice(item[0])
        }
      }
    }, [_c('span', {
      class: {
        checked: _vm.model[item[0]]
      }
    }), _vm._v(_vm._s(item[1]))])])
  }))])]), (_vm.hasSystemIndice) ? _c('div', {
    staticClass: "system-indices"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("系统转化指标：")]), _c('div', {
    staticClass: "control"
  }, [_c('ul', [_vm._l((_vm.system), function(item) {
    return _c('li', {
      key: item[1]
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.changeIndice(item[0])
        }
      }
    }, [_c('span', {
      class: {
        checked: _vm.model[item[0]]
      }
    }), _vm._v(_vm._s(item[1]))])])
  }), _c('li', [_c('router-link', {
    staticClass: "btn btn-primary btn-icon mgleft8",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "to": "/setting/gencode"
    }
  }, [_vm._v("获取代码监测转化指标")])], 1)], 2)])]) : _vm._e(), _c('div', {
    staticClass: "conv-indices"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("自定义转化指标：")]), _c('div', {
    staticClass: "control"
  }, [_c('ul', [_vm._l((_vm.trans), function(item) {
    return _c('li', {
      key: item[1]
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.changeIndice(item[0])
        }
      }
    }, [_c('span', {
      class: {
        checked: _vm.model[item[0]]
      }
    }), _vm._v(_vm._s(item[1]))])])
  }), _c('li', [_c('router-link', {
    staticClass: "btn btn-primary btn-icon mgleft8",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "to": "/setting/trans"
    }
  }, [_vm._v("手动设置转化指标")])], 1)], 2)])]), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "font-weight": "normal"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("当前已选中 " + _vm._s(_vm.checkedCount) + " 项")]), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('a', {
    staticClass: "restore-btn btn btn-primary btn-icon mgleft8",
    on: {
      "click": _vm.restoreIndices
    }
  }, [_vm._v("恢复默认指标")])]), _c('a', {
    staticClass: "btn btn-default btn-small pull-right mgTop4",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("取消")]), _c('a', {
    staticClass: "btn btn-primary btn-small pull-right mgTop4",
    attrs: {
      "type": "button",
      "disabled": _vm.checkedCount == 0
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirm($event)
      }
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ffc14cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ffc14cc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/custom-indice.vue
// module id = 760
// module chunks = 0